import cf from './cf';
import c20v from './c20v_20211024';

export default class c20v1a extends c20v {

  constructor(props) { // state の宣言だけでは駄目な模様
    super(props);
//    this.class = this.constructor.name;
    this.d_viewDefs = { // 団体本体
      class: 'c20v1a',
      name: 'クライアント'
    };
    this.state = cf.myRN_crt_stss(
      this.$cd_stss,
      this.$id_stss
    );
  }

}
/*
 Copyright 2020 Yukio Shinohara All rights reserved.
 */
